import { render, staticRenderFns } from "./ModalAviso.vue?vue&type=template&id=c2a3eda0&scoped=true"
import script from "./ModalAviso.vue?vue&type=script&lang=js"
export * from "./ModalAviso.vue?vue&type=script&lang=js"
import style0 from "./ModalAviso.vue?vue&type=style&index=0&id=c2a3eda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a3eda0",
  null
  
)

export default component.exports